module.exports = __webpack_public_path__ + "img/cardupWhite.eae9739e.png";